import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEO from '../../components/feature/SEO';
import AppHeroSection from './components/AppHeroSection';
import StepsSection from './components/StepsSection';
import FeaturesSection from './components/FeaturesSection';
import PersonasSection from './components/PersonasSection';
import WaitlistSection from './components/WaitlistSection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const schema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'SoftwareApplication',
      '@id': `${siteUrl}/app#software`,
      name: 'OxyAI',
      alternateName: 'OxyAI – Oxygen Deficiency Screening App',
      url: `${siteUrl}/app`,
      applicationCategory: 'HealthApplication',
      operatingSystem: 'iOS, Android',
      description:
        'OxyAI is an AI-powered mobile app by Diatomic Life Foundation that screens for oxygen deficiency, helping families detect and address health issues early.',
      offers: {
        '@type': 'Offer',
        price: '0',
        priceCurrency: 'INR',
        availability: 'https://schema.org/ComingSoon',
      },
      publisher: {
        '@type': 'NGO',
        '@id': `${siteUrl}/#organization`,
        name: 'Diatomic Life Foundation',
        url: siteUrl,
      },
      featureList: [
        'AI-powered oxygen deficiency screening',
        'Personalized health insights',
        'Family health tracking',
        'Early detection alerts',
      ],
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/app#webpage`,
      url: `${siteUrl}/app`,
      name: 'OxyAI App | AI-Powered Oxygen Deficiency Screening – Diatomic Life Foundation',
      isPartOf: { '@id': `${siteUrl}/#website` },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
          { '@type': 'ListItem', position: 2, name: 'OxyAI App', item: `${siteUrl}/app` },
        ],
      },
    },
  ],
};

export default function App() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <SEO
        title="OxyAI App | AI-Powered Oxygen Deficiency Screening – Diatomic Life Foundation"
        description="Download OxyAI, the AI-powered app that screens for oxygen deficiency in minutes. Free for families. Built by Diatomic Life Foundation to make oxygen health accessible to all."
        keywords="OxyAI app, oxygen deficiency screening app, AI health app, Diatomic Life Foundation app"
        canonical={`${siteUrl}/app`}
        schemaJson={schema}
      />
      <Header />
      <main>
        <AppHeroSection />
        <StepsSection />
        <FeaturesSection />
        <PersonasSection />
        <WaitlistSection />
      </main>
      <Footer />
    </div>
  );
}
